import myAxios from "../../utils/axiosWrapper";
import getConfig from "../../conf/config";
import { auth } from "../../conf/firebase";
import {
  LISTS_FETCH,
  LISTS_FETCH_FAILURE,
  LISTS_FETCH_SUCCESS,
  LIST_DATA_FETCH,
  LIST_DATA_FETCH_FAILURE,
  LIST_DATA_FETCH_SUCCESS,
} from "../actionTypes";

export const fetchLists = () => {
  return async (dispatch) => {
    const { currentUser } = auth;
    if (!currentUser || currentUser === null) {
      console.error("Not fetching analytics, user not authenticated");
      return;
    }

    try {
      dispatch({ type: LISTS_FETCH });

      const response = await myAxios.get(`${getConfig().API_URL}/audio/api/v1/lists`);
      const retrievedLists = response?.data?.[0]?.lists || [];

      dispatch({ type: LISTS_FETCH_SUCCESS, payload: retrievedLists });
    } catch (error) {
      console.log({ error });
      dispatch({ type: LISTS_FETCH_FAILURE, payload: error.message });
      throw error;
    }
  };
};

export const fetchListData = (listId) => {
  return async (dispatch) => {
    const { currentUser } = auth;
    if (!currentUser || currentUser === null) {
      console.error("Not fetching analytics, user not authenticated");
      return;
    }

    try {
      dispatch({ type: LIST_DATA_FETCH });

      const response = await myAxios.get(`${getConfig().API_URL}/audio/api/v1/lists/${listId}`);
      const listData = response?.data?.[0]?.list || null;

      dispatch({ type: LIST_DATA_FETCH_SUCCESS, payload: listData });
    } catch (error) {
      console.log({ error });
      dispatch({ type: LIST_DATA_FETCH_FAILURE, payload: error.message });
      throw error;
    }
  };
};
